import request from '@/utils/request'

// 收发明细账单据类型列表
export function apiGetDeliveryOrderTypeList (query) {
  return request({
    url: '/inv/invOnhandQuantities/findAsnAndDeliveryOrderTypeList',
    method: 'get',
    params: query
  })
}

// 查询收发明细账列表（加工园仓）
export function apiGetWmsSfMXZDetailList (query) {
  return request({
    url: '/inv/invOnhandQuantities/wmsSfMXZDetailList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiWmsSfMXZDetailExport (data) {
  return request({
    url: '/inv/invOnhandQuantities/v2/wmsSfMXZDetailExport',
    method: 'post',
    data: data
  })
}
